<template>
  <div>
    <section class="section">
      <div class="container">
        <h1 class="title">Welcome to {{this.$appName}}</h1>
        <h2 class="subtitle">
        </h2>
        <br />
        <br />
        <br />
        <br />
        <div>
          <p>
            <i>
              <strong>Boss</strong> [/bɒs/]: excellent; outstanding.
            </i>
          </p>
          <p>
            <i>
              <strong>Pour</strong> [/pɔː/]: an abundant or continuous flow of homebrew.
            </i>
          </p>
        </div>
      </div>
    </section>

    <br />
  </div>
</template>
    
<script>
export default {
  name: "start"
};
</script>
<style scoped>
.center-div {
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100px;
  height: 100px;
  background-color: #ccc;
  border-radius: 3px;
}
</style>